import { MenuItem, TextField } from "@mui/material";
import { Role } from "../../../../enums";
import { makeStyles } from "@mui/styles";
import { v2theme } from "../../../../styles/Theme";

type RoleSelectProps = {
  value: Role | "";
  onChange: (value: Role) => void;
  currentUserRole: Role;
  disabled?: boolean;
};

const allowedRoles = {
  [Role.super]: [Role.super, Role.admin, Role.teacher, Role.student],
  [Role.admin]: [Role.admin, Role.teacher, Role.student],
  [Role.teacher]: [Role.teacher, Role.student],
  [Role.student]: [],
} as const;

const useStyle = makeStyles((theme) => ({
  gridItem: {
    padding: "0px !important",
  },
  inputText: {
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: v2theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: v2theme.palette.primary.main,
      },
    },
  },
}));

export function RoleSelect(props: RoleSelectProps) {
  const classes = useStyle();
  return (
    <TextField
      className={classes.inputText}
      value={props.value}
      onChange={(e) => props.onChange(e.target.value as Role)}
      label="Role"
      select
      fullWidth
      disabled={props.disabled}
      required>
      {allowedRoles[props.currentUserRole].map((role) => (
        <MenuItem key={role} value={role}>
          {role}
        </MenuItem>
      ))}
    </TextField>
  );
}
